import React from "react";

const Cartel = ({ fecha }) => {
  // Creamos una variable que almacene la fecha actual usando new Date()
  const hoy = new Date();

  // Creamos una variable que almacene la fecha de la clase usando new Date(fecha)
  const fechaClase = new Date(fecha);

  // Comparamos las dos fechas usando los operadores numéricos
  const clasePasada = hoy > fechaClase;

  // Retornamos un elemento que tenga un color y un texto según el resultado de la comparación
  return (
    <div
      className={`text-white font-bold text-lg sm:text-xl lg:text-2xl tracking-tight rounded-2xl overflow-hidden px-4 py-2 mb-2 ${
        clasePasada
          ? "bg-red-500 shadow-lg shadow-red-500/25"
          : "bg-green-500 shadow-lg shadow-green-500/25"
      }`}
    >
      {clasePasada ? "Clase pasada" : "Clase disponible"}
    </div>
  );
};

export default Cartel;
